// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__346iZ","Success":"Button_Success__sU36H","Fail":"Button_Fail__1m5lH"};